import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FullAddress } from '../models/address.models';
import { TogetherBaseAddress } from './../models/api.models';
import { AddressComponentService } from './../services/address.component.service';

@Component({
    selector: 'app-address-display',
    templateUrl: './address.display.component.html',
    standalone: false
})
export class AddressDisplayComponent implements OnInit {
  address: TogetherBaseAddress;
  constructor(service: AddressComponentService) {
    this.address = service.address;
  }

   /**
   * The iterator of the address. This is required because the iterator MUST be re-inserted back where it was.
   *
   * @type {number}
   * @memberof AddressDisplayComponent
   */
  @Input() index: number = 0;

  ngOnInit() {
  }

}
